import styled from "styled-components/macro";

export const AppContainer = styled.div`
  /* padding-top: 48px; */
  /* margin-inline: 16px; */
`;
